<template>
  <div v-if="fieldData.fieldCname == 'cust_phone'">
    <span>{{fieldData.__value__key__ | encryptionFilterSens({fieldData,allFieldsVal})}}</span>
    <Icon
        v-if='fieldData.__value__key__ && iosCall'
      style="padding-left:8px;cursor: pointer;"
      size="18"
      type="ios-call"
      @click="onClickDoubleCall"
    />
  </div>
  <div v-else>
       <span>{{fieldData.__value__key__ | encryptionFilterSens({fieldData,allFieldsVal})}}</span>
  </div>
</template>

<script>
import minixBase64enDe from './minixBase64enDe.js'
export default {
  props: {
    fieldData: Object,
    allFieldsVal: Object,
    doubleCallFlag: Boolean
  },
  data() {
    return {
      iosCall: window.localStorage.getItem("returnCallId")?true:false
    }
  },
  filters:{
      encryptionFilterSens(value,_this){
          return minixBase64enDe.base64Filters(_this.fieldData.fieldCname,value,_this.allFieldsVal.encryption_id)
      }
  },
  methods: {
    onClickDoubleCall() {
      // 新建不可打
      console.log('新建不可打', this.allFieldsVal, this.doubleCallFlag)
      if (!this.doubleCallFlag) {
        return
      }
      let params = {
        mtId: this.allFieldsVal.mt_id,
        encryption: this.allFieldsVal.encryption == '是' ? '1' : '0',
        called: this.allFieldsVal.encryption == '是'?minixBase64enDe.base64En(this.fieldData.__value__key__,'1'):this.fieldData.__value__key__,
        callerChangeVoice: '1',
        calledChangeVoice: '1',
        callerChangeVoiceLength: '+10',
        calledChangeVoiceLength: '+10'
      }
      this.$http
        .get('/scwf/doubleCall/call', { params })
        .then(({ data }) => {
          if (data.returnCode == 0) {
            this.$Message.success('双呼成功')
          } else {
            this.$Message.error(data.returnMessage)
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
</script>

<style>
</style>